import {
  AliceCardFundingStatus,
  FormNameEnum,
  isNotNull,
  OrganizationDetailFragment,
} from '@alice-financial/alice-sdk'
import { Alert, Button, Collapse, Grid, Typography } from '@alice-financial/pretext-ui'
import UploadIcon from '@mui/icons-material/Upload'
import * as React from 'react'
import { ACHMandate } from '../externalServices/stripe/ConfirmACHConnection'
import { QuestionPage } from '../survey/types'
import { hasBillingConnected } from './billing/billingUtils'
import { PagedOrgForm } from './survey/PagedOrgForm'
import { useOrgFormStatus } from './survey/useOrgFormFields'

type UploadBankAccountsProps = {
  type: 'billing' | 'banking'
  org: OrganizationDetailFragment
  formName: FormNameEnum
  formVersion: number
  pages: QuestionPage[]
  onCompleteReturnTo: string
}
export const UploadBankAccounts = ({
  org,
  type,
  formName,
  formVersion,
  pages,
  onCompleteReturnTo,
}: UploadBankAccountsProps) => {
  const formStatus = useOrgFormStatus(org.id, formName, formVersion)
  const [isUploadOpen, setIsUploadOpen] = React.useState(false)
  const [dialogView, setDialogView] = React.useState<'ach-mandate' | 'upload'>('ach-mandate')
  const paygroups = org.employers.filter(isNotNull)

  if (type === 'billing') {
    if (org.billing?.hasUnifiedBilling) return null
    if (paygroups.filter((p) => !hasBillingConnected(p)).length < 2) {
      return null
    }
  }
  if (type === 'banking') {
    if (org.aliceCardProgram.hasUnifiedBanking) return null
    if (paygroups.filter((p) => p.aliceCardFunding.status !== AliceCardFundingStatus.Connected).length < 2) {
      return null
    }
  }

  return (
    <Alert severity="info" sx={{ p: 1 }}>
      <Collapse in={!isUploadOpen && formStatus !== 'complete'}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid>
            <Typography variant="body2" color="text.secondary" fontWeight="bold">
              Bulk upload
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Upload a file containing account and routing numbers here (optional).
            </Typography>
          </Grid>
          <Grid>
            <Button
              size="small"
              variant="outlined"
              onClick={() => setIsUploadOpen(!isUploadOpen)}
              endIcon={<UploadIcon />}
            >
              Upload file
            </Button>
          </Grid>
        </Grid>
      </Collapse>
      <Collapse in={isUploadOpen || formStatus === 'complete'}>
        {formStatus !== 'complete' && dialogView === 'ach-mandate' && (
          <ACHMandate onAccept={() => setDialogView('upload')} type={type} />
        )}
        {(formStatus === 'complete' || dialogView === 'upload') && (
          <PagedOrgForm
            formName={formName}
            formVersion={formVersion}
            pages={pages}
            onCompleteReturnTo={onCompleteReturnTo}
          />
        )}
      </Collapse>
    </Alert>
  )
}
